export const iconFontAwesomeGamingPuzzlePiece = (
	<i className="fa-solid fa-puzzle-piece"></i>
);
